module.exports = __webpack_public_path__ + "img/magento-support-security_medium@2x.f9dd09b9.jpg";